import { Grid, Modal, Typography } from "@mui/material";
import { GradientButton } from "components/GradientButton";
import React from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import api from "_api";
import CustomTable from "components/TableExplanded/Table";
import useColumns from "./columns/mainColumns";
import useColumnsTwo from "./columns/subColumns";
import useProductData from "./data/data";
import CustomPagination from "components/TableExplanded/Pagination";
import ViewModal from "components/Modal/SuperAdmin/view/viewAllProducts";

const AllProduct = ({ className }) => {
  const [searchTerm, setSearchTerm] = React.useState("");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [isModalOpen, setModalOpen] = React.useState(false);
  const [isViewModalOpen, setViewModalOpen] = React.useState(false);
  const [selectedProduct, setProduct] = React.useState(null);
  const [viewProduct, setViewProduct] = React.useState(null);
  const [filteredRows, setFilteredRows] = React.useState([]);
  const [selectedDateRange, setSelectedDateRange] = React.useState([
    null,
    null,
  ]);
  const [fetchData, setFetchData] = React.useState();

  const handleViewOpen = () => {
    setViewModalOpen(!isViewModalOpen);
    if (viewProduct && isViewModalOpen) setViewProduct(null);
  };
  const fetchProductData = async () => {
    try {
      // const { data, isStatus } = await api.product.getOrder();
      const { data: allProducts, isStatus: status } =
        await api.super_admin.getAllProductsPawn();
      console.log("allProducts", allProducts);

      if (status) setFetchData(allProducts);
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };
  React.useEffect(() => {
    fetchProductData();
  }, []);

  const data = useProductData(fetchData);
  console.log({ data });

  const columns = useColumns(
    setViewProduct,
    setProduct,
    handleViewOpen
    // handleModalOpen
  );

  const columnsInside = useColumnsTwo();
  React.useEffect(() => {
    setFilteredRows(data);
  }, [data]);
  // console.log(fetchData)
  React.useEffect(() => {
    console.log("viewPro", viewProduct);
  }, [viewProduct]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className={className}>
      <Grid container spacing={2} style={{ marginBottom: "16px" }}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography component="div" style={{ fontSize: "32px" }}>
            รายการทั้งหมด
          </Typography>
        </Grid>
      </Grid>

      {/* <SearchBar
        searchTerm={searchTerm}
        //   handleSearchChange={handleSearchChange}
        //   handleSearchClick={handleSearchClick}
        //   handleClear={handleClear}
        //   handleDateRangeChange={handleDateRangeChange}
        fieldNames={"buyItems"}
        QRCode={false}
      /> */}

      <CustomTable
        columns={columns}
        columnsInside={columnsInside}
        data={filteredRows}
        page={page}
        rowsPerPage={rowsPerPage}
      />

      <CustomPagination
        count={filteredRows.length}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
      {/* 
      <Modal
        open={isModalOpen}
        onClose={handleModalOpen}
        selectedProduct={selectedProduct}
        fetchProductData={fetchProductData}
        disableBackdropClick // Prevent clicking outside
        disableEscapeKeyDown // Prevent pressing `Esc`
      /> */}

      <ViewModal
        open={isViewModalOpen}
        onClose={handleViewOpen}
        viewProduct={viewProduct}
      />
    </div>
  );
};
export default AllProduct;
